<template>
    <div class="card-header flex-wrap border">
        <h3 class="card-title align-items-start flex-column">
            <span class="card-label font-weight-bolder font-size-h3 pt-3" v-text="title"></span>
            <div class="bg-success px-4 py-1 text-white my-1 h6 rounded-sm">Acreditacion {{subtitle}}</div>
        </h3>
        <div class="card-toolbar">
            <router-link class="btn btn-secondary btn-sm" :to="back">
                <i class="el-icon-arrow-left"></i> volver
            </router-link>
        </div>
    </div>
</template>
<script>
export default {
    props:["title","subtitle", "back"]
}
</script>